import { Text } from 'braid-design-system';
import { SmartTextLink } from 'scoobie';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import type { Breadcrumb } from '#src/components/Breadcrumbs/Breadcrumbs.tsx';
import { JobAdLookupSection } from './components/JobAdLookupSection.tsx';

export const JobAdsPage = ({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) => (
  <BasePage title="Job ads" breadcrumbs={breadcrumbs}>
    <Text>
      <SmartTextLink href="/use-cases/job-posting/managing-job-ads/querying-a-job-ad">
        Query
      </SmartTextLink>{' '}
      and{' '}
      <SmartTextLink href="/use-cases/job-posting/managing-job-ads/previewing-a-job-ad">
        preview
      </SmartTextLink>{' '}
      job ads posted by your hirers.
    </Text>

    <JobAdLookupSection key="JobAdLookupSection" />
  </BasePage>
);
